import { useContext } from 'react';
import { FetchContext, type UploadImageParams } from '@src/scenario-editor/providers/fetch.context';

export type { UploadImagePayload, UploadImageParams } from '@src/scenario-editor/providers/fetch.context';

interface Image {
  id: string;
  mimeType: string;
  signedUrl: string;
  cropMeta?: {width: number, height: number, x: number, y: number, unit: string};
}

export const useUploadImage = (): {
  uploadImage: (params: UploadImageParams) => Promise<Image>;
  fetchImagesUrlById: (ids: string[], size?: string, withCrop?: boolean) => Promise<Record<string, string>>;
  fetchImageContentById: (ids: string[], size?: string, withCrop?: boolean) => Promise<Record<string, string>>;
} => {
  const fetchContext = useContext(FetchContext);

  if (!fetchContext) {
    throw new Error('FetchContext is not provided');
  }

  const uploadImage = async (uploadImageParams: UploadImageParams) => {
    console.log('upload image params', uploadImageParams);
    const image = await fetchContext.uploadImage(uploadImageParams);

    console.log('upload image', image);

    return ({
      id: image.data.userUpload.id,
      mimeType: image.data.userUpload.mimeType,
      signedUrl: image.data.signedUrl
    }) as Image;
  };

  const fetchImagesUrlById = async (ids: string[], size?: string, withCrop?: boolean) => {
    const imageUrl = await fetchContext.fetchImageUrlById(ids, size, withCrop);

    return imageUrl?.data;
  }

  const fetchImageContentById = async (ids: string[], size?: string, withCrop?: boolean) => {
    const imageContent = await fetchContext.fetchImageContentById(ids, size, withCrop);

    return imageContent?.data;
  }

  return { uploadImage, fetchImagesUrlById, fetchImageContentById };
}
